<template>
  <th
    data-sb-regression="sb-sortable-table-head"
    :class="[
      'sb-table-head',
      'sb-table-head--sortable',
      isActive ? 'sb-table-head--sortable-active' : ''
    ]"
    scope="col"
    @click="sort"
  >
    <div class="sb-table-head__wrapper">
      <template v-if="$slots.default">
        <!--
          @slot slot to show sortable head column
        -->
        <slot />
      </template>
      <span class="sb-table-head-sort-icon-wrapper sb-table-head-sort-icon-wrapper--right">
        <i
          aria-hidden="true"
          :class="iconUpClasses"
        />
        <i
          aria-hidden="true"
          :class="iconDownClasses"
        />
      </span>
    </div>
  </th>
</template>
<script>
import isEqual from 'lodash/isEqual';

export default {
  name: 'SbSortableTableHead',
  inject: ['sbTableSort', 'sortTable'],
  props: {
    item: Object, // eslint-disable-line

    tooltip: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
    * If sorting logic will be done by an API.
    */
    apiSorting: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
    * Only emmited when apiSorting is true.
    */
    'api-sort',
  ],
  computed: {
    descending() {
      return this.sbTableSort.descending;
    },
    sortColumn() {
      return this.sbTableSort.sortColumn;
    },
    isActive() {
      return isEqual(this.item, this.sortColumn);
    },
    iconUpClasses() {
      const classes = [
        'sb-table-head-sort-icon',
        'sb-icon-long-arrow-up',
      ];

      const isApiSorting = this.apiSorting && this.item.sortingState === 'asc';
      const isClientSideSorting = this.isActive && !this.descending;

      if (isApiSorting || isClientSideSorting) {
        classes.push('sb-table-head-sort-icon--active');
      }

      return classes;
    },
    iconDownClasses() {
      const classes = [
        'sb-table-head-sort-icon',
        'sb-icon-long-arrow-down',
      ];

      const isApiSorting = this.apiSorting && this.item.sortingState === 'desc';
      const isClientSideSorting = this.isActive && this.descending;

      if (isApiSorting || isClientSideSorting) {
        classes.push('sb-table-head-sort-icon--active');
      }

      return classes;
    },
  },
  methods: {
    sort() {
      if (this.apiSorting) {
        this.$emit('api-sort', this.item);
        return;
      }

      this.sortTable(this.item);
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Table/style/sb-sortable-table-head.scss';
</style>
